<template>
  <div>
   <loader v-if="pageLoader"></loader>
    <div class="accountSetting notifications pl-xl-4" v-if="!pageLoader && notificationEnablegetSettings && notificationEnablegetSettings.length > 0">
    <div class="border-bottom pb-3 mb-4">
      <h3 class="medium">Notifications</h3>
      <p>
        We may still send you important notifications about your account outside
        of your notifications settings
      </p>
    </div>
    <!-- <div class="border-bottom pb-4 mb-4">
      <h5 class="medium mb-4">Wallets</h5>
      <div class="d-flex align-items-center justify-content-between">
        <p class="mb-0">When someone send me a Crypto</p>
        <label class="toggleSwitch">
          <input type="checkbox" />
          <span class="slider round"></span>
        </label>
      </div>
    </div>
    <div class="border-bottom pb-4 mb-4">
      <h5 class="medium mb-4">Market Updates</h5>
      <div class="d-flex align-items-center justify-content-between mb-4">
        <p class="mb-0">When my watchlist reach specific amounts</p>
        <label class="toggleSwitch">
          <input type="checkbox" />
          <span class="slider round"></span>
        </label>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-4">
        <p class="mb-0">When I receive a recommendation for my crypto trades</p>
        <label class="toggleSwitch">
          <input type="checkbox" />
          <span class="slider round"></span>
        </label>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-4">
        <p class="mb-0">When I receive market updates</p>
        <label class="toggleSwitch">
          <input type="checkbox" />
          <span class="slider round"></span>
        </label>
      </div>
    </div>
    <div class="pb-4 mb-4">
      <h5 class="medium mb-4">Reminders</h5>
      <div class="d-flex align-items-center justify-content-between mb-4">
        <p class="mb-0">
          Receive push notifications of updates you might have missed
        </p>
        <label class="toggleSwitch">
          <input type="checkbox" id="reminder1" v-model="notification[1].status" true-value="1" false-value="0"/>
          <span class="slider round"></span>
        </label>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-4">
        <p class="mb-0">
          Receive text messages of updates you might have missed
        </p>
        <label class="toggleSwitch">
          <input type="checkbox" id="reminder2" v-model="notification[2].status" true-value="1" false-value="0"/>
          <span class="slider round"></span>
        </label>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-4">
        <p class="mb-0">Receive emails of updates you might have missed</p>
        <label class="toggleSwitch">
          <input type="checkbox" id="reminder3" v-model="notification[3].status" true-value="1" false-value="0"/>
          <span class="slider round"></span>
        </label>
      </div>
    </div>
    <div class="pb-4 mb-4">
      <h5 class="medium mb-4">Register</h5>
      <div class="d-flex align-items-center justify-content-between mb-4">
        <p class="mb-0">
          Receive push notifications of updates you might have missed
        </p>
        <label class="toggleSwitch">
          <input type="checkbox" id="register" v-model="notification[0].status" true-value="1" false-value="0"/>
          <span class="slider round"></span>
        </label>
      </div>
    </div> -->
    <div class="pb-4 mb-4" v-for="list,key in notificationEnablegetSettings">
      <h5 class="medium mb-4">{{list.type.replace(/_/g,' ')}}</h5>
      <div class="d-flex align-items-center justify-content-between mb-4">
        <p class="mb-0">
          {{list.text}}
        </p>
        <label class="toggleSwitch">
          <input type="checkbox" :id="list.id" v-model="notification_vmodel[list.id]" true-value="1" false-value="0"/>
          <span class="slider round"></span>
        </label>
      </div>
    </div>
    <div
      class="buttons d-flex align-items-center justify-content-end border-top pt-4 mt-4"
    >
      <a href="javascript:void(0)" class="cap_btn-b small mr-0 min-auto">Cancel</a>
      <a href="javascript:void(0)" @click="submitSettings()" class="cap_btn small">Save</a>
    </div>
  </div>

  <p v-else>
    Not any notification yet.
  </p>
</div>
</template>

<script>
import { registerStepsMixins } from "@/plugins/registerSteps";
// import editAddress from './edit_Address'
// import editNumber from './edit_Number'
export default {
  name: "accountprofile",
  mixins: [registerStepsMixins],
  data() {
    return {
      pageLoader: false,
      notification_msg: "",
      notification_type: "",
      // tab: '1',
      submitted: false,
      // editAddress: false,
      // editNumber: false,

      fname: "",
      mName: "",
      lname: "",
      dob: "",
      address: "",
      city: "",
      state: "",
      country: "",
      area_code: "",
      acc_type: "",
      OrganizationType: {
        0: "Company",
        1: "Self Managed Super Fund",
        2: "Discretionary/Unit Trust",
        3: "Others",
      },
      notification_vmodel: {}
    };
  },
  components: {
    // editAddress,
    // editNumber
  },

  methods: {
    create_image(url, name) {
      var stx = this.stxx;
      var link = document.createElement("a");
      link.download = name;
      link.href = url;
      link.click();
    },
    ChangeTab(val) {
      this.tab = val;
      // this.editAddress = false
      // this.editNumber = false
      this.pageLoader = false;
    },
    Submit() {
      const _that = this;
      _that.submitted = true;
      _that.$validator.validate().then((valid) => {
        if (valid) {
          let input_json = {
            globalParams: {
              f_name: _that.fname,
              m_name: _that.mName,
              l_name: _that.lname,
              dob: _that.dob,
              Address: _that.address,
              City: _that.city,
              State: _that.state,
              Country: _that.country,
              Areacode: _that.area_code,
              Acc_type: _that.acc_type,
            },
            localParams: {
              parameter: _that,
            },
          };
        }
      });
    },
    submitSettings(){
      let json = {}, array = [];
      for(var key in this.notification_vmodel){
        json = {}
        if(parseInt(this.notification_vmodel[key]) == 1){
          json['notification_id'] = key
          array.push(json)
        }
      }
      this._runNotificationSettings({ 'globalParams' :{"settings": array}, 'localParams' :{ "parameter" : this } })
    },
    // enableNotifi(){
    //   this._runNotificationgetSettings({ 'globalParams' :{ }, 'localParams' :{ "parameter" : this } })
    // }
  },
  created() {
    this.pageName("Account Profile");
    this._runNotificationgetSettings({ 'globalParams' :{ }, 'localParams' :{ "parameter" : this } })
    setTimeout( () =>{
      this._runNotificationEnablegetSettings({ 'globalParams' :{ }, 'localParams' :{ "parameter" : this }})
    },1000)
    // this._runGetProfileInfo({
    //     globalParams: {

    // 	},
    //     localParams: {
    //         "parameter": this
    //     }
    // })
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/settings/files/notifications.vue